import { createCallbackClient, createClient } from '@connectrpc/connect';
import { BlazeDeviceService } from '@wavingroup/iot-core/gen/ts/wavin/blaze/v1/blaze_device_service_pb';
import { blazeTransport } from '~/services/api/service-transport';

export const blazeDevicePromiseClient = createClient(
  BlazeDeviceService,
  blazeTransport,
);

export const blazeDeviceClientCallback = createCallbackClient(
  BlazeDeviceService,
  blazeTransport,
);
